import React from 'react';
import type { CashSummary } from '../../types/cash';

function eur(n: number) {
  return n.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
}

export function CashDrawerMovementsTable(props: { items: CashSummary['drawerMovements']['items'] }) {
  if (!props.items.length) {
    return <div className="text-muted">Nessun movimento.</div>;
  }

  return (
    <div className="table-responsive">
      <table className="table table-sm align-middle mb-0">
        <thead>
          <tr>
            <th>Ora</th>
            <th>Tipo</th>
            <th className="text-end">Importo</th>
            <th>Causale</th>
            <th>Origine</th>
          </tr>
        </thead>
        <tbody>
          {props.items.map((m) => {
            const typeBadge =
              m.type === 'IN' ? 'text-bg-success' : 'text-bg-warning';

            return (
              <tr key={m.id}>
                <td>{new Date(m.at).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}</td>
                <td>
                  <span className={`badge ${typeBadge}`}>{m.type}</span>
                </td>
                <td className="text-end fw-semibold">{eur(m.amount)}</td>
                <td>{m.reason ?? <span className="text-muted">—</span>}</td>
                <td>
                  <span className={`badge ${m.source === 'MIDWARE' ? 'text-bg-secondary' : 'text-bg-primary'}`}>
                    {m.source}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}